export const WP_URL =
  process.env.REACT_APP_WP_URL || "https://piscatello.wpenginepowered.com";
